'use client'

import AgentPromoted from '@component/card/agent/promoted'
import SectionLayout from '@component/layout/section'
import SectionSwiper from '@component/layout/section/swiper'

export default function Content ({
  data
}) {
  return data && data.length > 0 && (
    <SectionLayout title='Get a free, no obligation appraisal from our top agents today'>
      <SectionSwiper data={data} Card={AgentPromoted}></SectionSwiper>
    </SectionLayout>
  )
}